// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recharts-wrapper.chart {
	width: 100%;
	margin: 0px;
	/* transform: translate(0px, 0); */
}
/* margin and padding doesnt work on g elements */
.recharts-default-legend {
	margin: 10px;
}
.recharts-legend-wrapper {
	transform: translate(0px, -25px);
	padding: 0px;
}
.myLegend {
	position: absolute;
	top: 10;
	right: 0;
}

.recharts-layer.recharts-brush.myBrush > rect[fill="#fff"] {
	fill: var(--primary-color2);
	fill-opacity: 0.1;
}

.recharts-curve.recharts-tooltip-cursor {
	/* transform: translate(0px, 0); */
}

.recharts-layer.recharts-brush {
	/* transform: translate(0, -2px); */
}
.recharts-layer.recharts-brush .recharts-brush-slide {
	fill: var(--primary-color1) !important;
	fill-opacity: 1 !important;
}
.recharts-layer.recharts-brush-traveller rect {
	fill: var(--primary-color2);
}

.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {
	font-size: 0.8rem;
}
.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {
	font-size: 0.8rem;
}
.recharts-surface {
	/* transform: translate(0px, 0px); */
}

@media (max-width: 380px) {
	.recharts-legend-wrapper {
		transform: translate(20px, -25px);
		padding: 0px;
	}
	.recharts-surface {
		/* transform: translate(0px, 0px); */
	}
}
@media (min-width: 500px) {
	.recharts-wrapper.chart {
		width: 100%;
	}
	/* margin and padding doesnt work on g elements */
	.recharts-default-legend {
		margin: 10px;
		/* transform:translate(-30px,0) */
	}
	.recharts-legend-wrapper {
		transform: translate(20px, -30px);
	}
	.myLegend {
		position: absolute;
		top: 0;
		right: 0;
	}
	.recharts-layer.recharts-brush.myBrush > rect[fill="#fff"] {
		fill: var(--primary-color2);
		fill-opacity: 0.1;
	}

	.recharts-layer.recharts-brush {
		transform: translate(0, 4px);
	}
	.recharts-layer.recharts-brush .recharts-brush-slide {
		fill: var(--primary-color1) !important;
		fill-opacity: 1 !important;
	}
	.recharts-layer.recharts-brush-traveller rect {
		fill: var(--primary-color2);
	}

	.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {
		font-size: 0.8rem;
	}
	.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {
		font-size: 0.8rem;
	}
	.recharts-brush-texts {
		transform: translate(0px, 0px);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/Plotter/rechart.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,WAAW;CACX,kCAAkC;AACnC;AACA,iDAAiD;AACjD;CACC,YAAY;AACb;AACA;CACC,gCAAgC;CAChC,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;AACA;CACC,sCAAsC;CACtC,0BAA0B;AAC3B;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC;EACC,iCAAiC;EACjC,YAAY;CACb;CACA;EACC,oCAAoC;CACrC;AACD;AACA;CACC;EACC,WAAW;CACZ;CACA,iDAAiD;CACjD;EACC,YAAY;EACZ,iCAAiC;CAClC;CACA;EACC,iCAAiC;CAClC;CACA;EACC,kBAAkB;EAClB,MAAM;EACN,QAAQ;CACT;CACA;EACC,2BAA2B;EAC3B,iBAAiB;CAClB;;CAEA;EACC,4BAA4B;CAC7B;CACA;EACC,sCAAsC;EACtC,0BAA0B;CAC3B;CACA;EACC,2BAA2B;CAC5B;;CAEA;EACC,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,8BAA8B;CAC/B;AACD","sourcesContent":[".recharts-wrapper.chart {\n\twidth: 100%;\n\tmargin: 0px;\n\t/* transform: translate(0px, 0); */\n}\n/* margin and padding doesnt work on g elements */\n.recharts-default-legend {\n\tmargin: 10px;\n}\n.recharts-legend-wrapper {\n\ttransform: translate(0px, -25px);\n\tpadding: 0px;\n}\n.myLegend {\n\tposition: absolute;\n\ttop: 10;\n\tright: 0;\n}\n\n.recharts-layer.recharts-brush.myBrush > rect[fill=\"#fff\"] {\n\tfill: var(--primary-color2);\n\tfill-opacity: 0.1;\n}\n\n.recharts-curve.recharts-tooltip-cursor {\n\t/* transform: translate(0px, 0); */\n}\n\n.recharts-layer.recharts-brush {\n\t/* transform: translate(0, -2px); */\n}\n.recharts-layer.recharts-brush .recharts-brush-slide {\n\tfill: var(--primary-color1) !important;\n\tfill-opacity: 1 !important;\n}\n.recharts-layer.recharts-brush-traveller rect {\n\tfill: var(--primary-color2);\n}\n\n.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {\n\tfont-size: 0.8rem;\n}\n.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {\n\tfont-size: 0.8rem;\n}\n.recharts-surface {\n\t/* transform: translate(0px, 0px); */\n}\n\n@media (max-width: 380px) {\n\t.recharts-legend-wrapper {\n\t\ttransform: translate(20px, -25px);\n\t\tpadding: 0px;\n\t}\n\t.recharts-surface {\n\t\t/* transform: translate(0px, 0px); */\n\t}\n}\n@media (min-width: 500px) {\n\t.recharts-wrapper.chart {\n\t\twidth: 100%;\n\t}\n\t/* margin and padding doesnt work on g elements */\n\t.recharts-default-legend {\n\t\tmargin: 10px;\n\t\t/* transform:translate(-30px,0) */\n\t}\n\t.recharts-legend-wrapper {\n\t\ttransform: translate(20px, -30px);\n\t}\n\t.myLegend {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t}\n\t.recharts-layer.recharts-brush.myBrush > rect[fill=\"#fff\"] {\n\t\tfill: var(--primary-color2);\n\t\tfill-opacity: 0.1;\n\t}\n\n\t.recharts-layer.recharts-brush {\n\t\ttransform: translate(0, 4px);\n\t}\n\t.recharts-layer.recharts-brush .recharts-brush-slide {\n\t\tfill: var(--primary-color1) !important;\n\t\tfill-opacity: 1 !important;\n\t}\n\t.recharts-layer.recharts-brush-traveller rect {\n\t\tfill: var(--primary-color2);\n\t}\n\n\t.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis {\n\t\tfont-size: 0.8rem;\n\t}\n\t.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis {\n\t\tfont-size: 0.8rem;\n\t}\n\t.recharts-brush-texts {\n\t\ttransform: translate(0px, 0px);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
